export var Size = {
  Sm: 'sm',
  Md: 'md'
};